module.exports = __webpack_public_path__ + "static/media/alanhunt.44a07aac.png";